// Define interfaces for the response structure
import { getHost } from '../utils/getHost'

export interface MetaData {
  meta: {
    created: string
    lastUpdated: string
  }
  links: {
    self: string
  }
  data: {
    type: string
    id: string
    attributes: {
      description: string
      noOfDataSets: number
      datasets: Dataset[]
    }
  }
}

export interface Dataset {
  name: string
  description: string
  resolution: string
  openDataSet: boolean
  columns: Column[]
  maxDateRange: string
  exportable: boolean
  filterParams: string
  filterValues: string
  scopes?: string[]
  resource?: string,
  routeAvailability?: string,
}

export interface Column {
  name: string
  type: string
  description: string
}

export const fetchMetaData = async (entity: string): Promise<MetaData> => {
  const metaUrl = getHost() + '/energy-data/v0/meta/' + entity
  const response = await fetch(metaUrl)

  if (!response.ok) {
    throw new Error(`Failed to fetch data: ${response.statusText}`)
  }

  return await response.json()
}
